<template>
  <div class="location-notification" v-if="showNotification">
    <div class="warning-icon material-icons">warning</div>
    <div class="notification-text" v-if="locationTooFar">{{ $t('message.locationTooFar') }}</div>
    <div class="notification-text" v-else>{{ $t('message.locationUnknown') }}</div>
    <button class="btn-ok btn btn-primary main-background secondary-text" @click="showDefaultLocationNotification(false)">{{ $t('button.ok') }}</button>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'

export default {
  name: 'LocationNotification',
  computed: {
    ...mapState({
      defaultLocationUsed: state => state.useDefaultLocation,
      notificationVisible: state => state.showDefaultLocationNotification,
      position: state => state.position
    }),
    ...mapGetters(['getUserDistance']),
    locationUnknown () {
      return !this.position
    },
    locationTooFar () {
      return this.getUserDistance !== undefined && this.getUserDistance > 10.0
    },
    showNotification () {
      return (this.notificationVisible &&
              (this.locationUnknown || this.locationTooFar)
      )
    }
  },
  methods: {
    ...mapMutations(['useDefaultLocation', 'showDefaultLocationNotification'])
  }
}
</script>

<style lang="stylus">
.location-notification {
  display: flex;
  align-items: center;
  padding: 5px;
  border-size: 1px;
  border-style: solid;
  background-color: white;
  .warning-icon {
    margin-right: 5px;
  }
  .notification-text {
    flex: 1;
    font-weight: bold;
  }
  .btn {
    margin-left: 5px;
  }
}
</style>
